var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArizona(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M217.382,53.114L101.795,33.956c-1.389,7.39-2.834,15.079-4.337,23.08c-2.967,15.777-9.237,7.125-10.559,5.279 c-1.319-1.848-5.38-3.695-5.38-3.695l-7.286,3.695l-2.905,37.741l-1.45,5.279c0,0,3.958,7.522,4.948,10.49 c0.99,2.969-2.572,4.552,4.75,9.303s-8.313,7.917-9.5,9.7c-1.188,1.782-5.149,15.638-5.149,15.638l-7.518,6.137l-0.794,12.273 l5.542,1.78l-1.385,6.136l-7.519,2.376l-1.461-0.202l-3.423,5.545l100.292,60.707l63.08,9.194l27.712-197.64L217.382,53.114z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArizona);
export default __webpack_public_path__ + "static/media/arizona.4a9e4876ff09119f6dd52d99a50ea776.svg";
export { ForwardRef as ReactComponent };